import api from "@/services/api"

export const retrieveOrderReceipt = async (
  orderId: string,
  query?: { isMerchant: boolean }
): Promise<{ receipt: string; webReceiptUrl: string }> => {
  const { body } = await api.get<{
    receipt: string
    webReceiptUrl: string
  }>(`/orders/${orderId}/receipt/`, { query })
  return body
}
